export const SPEC_URL =
  'https://github.com/jaydenseric/graphql-multipart-request-spec'
